export const FIELDSET_BODY_PADDING_SIZES = {
    box: {
        horizontal: '2xl',
        vertical: '2xl'
    },
    underline: {
        vertical: 'xl'
    }
};
//# sourceMappingURL=Fieldset.constants.js.map